import { render, staticRenderFns } from "./SocketNew.vue?vue&type=template&id=6664476a&scoped=true"
import script from "./SocketNew.vue?vue&type=script&lang=js"
export * from "./SocketNew.vue?vue&type=script&lang=js"
import style0 from "./SocketNew.vue?vue&type=style&index=0&id=6664476a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6664476a",
  null
  
)

export default component.exports